import React from 'react';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import { RichText, Icon, Button } from '@synergycms_core/components/generic';
import Form from '@synergycms_core/components/generic/Form';
import { RoomPreference } from '../RoomPreference';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { compose } from 'ramda';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { getRoomName } from '../../../utils';

const RoomPreferences = props => {
  const {
    blocks,
    sections,
    rooms,
    showRoomPreferences,
    langCode,
    toggleRoomPreferences,
    onChange,
    onBlur,
    hotelPreferences,

  } = props;
  const { classes } = props.theme.styles;

  return (
    <div className={classes.roomPreferences}>
      {blocks &&
      blocks.map(block => {
        const room = rooms.find(r => +r.get('id') === +block.get('room_id'));
        const adults = block.get('adults');
        const childs = block.get('childs');
        const babies = block.get('babies');
        const childsInfo = block.get('childs_info');

        let roomSection =
          sections &&
          (
            sections.find(
              s =>
                s.get('content_type_id') === block.get('room_id') &&
                s.get('content_type_occup_group_id') === block.get('occup_group_id') &&
                s.get('content_type_service_id') === block.get('service_id')
            ) ||
            sections.find(
              s =>
                s.get('content_type_id') === block.get('room_id') &&
                s.get('content_type_occup_group_id') === room.get('default_occup_group_id') &&
                s.get('content_type_service_id') === block.get('service_id')
            )
          );
        roomSection = roomSection && roomSection.getIn(['translations', langCode.toLowerCase()]);
        const needAddOccupName = (roomSection && roomSection.get('occup_group_id') !== block.get('occup_group_id')) || childsInfo;

        let roomOccupName =  getRoomName({ childs, adults, babies, childsInfo });

        let roomName = roomSection && (roomSection.get('title') || roomSection.get('default_title'));

        if(needAddOccupName) {
          roomName += roomOccupName;
        }

        const showRoomPreference = showRoomPreferences[block.get('idx')];
        return (
          <div key={block.get('idx')} className={classes.roomDetail}>
            <div className={classes.roomHeader}>
              <div className={classes.roomTitle}>
                <Icon innerStyle={[classes.bedIcon]} unicodeContent={'e14d'}/>
                <RichText translate={true} ucFirst={true} innerStyle={['roboto24Black']}>
                  _%personaliza tu habitación%_
                </RichText>
              </div>
              <div className={classes.roomSubTitle}>
                <RichText innerStyle={['roboto13Black400']}>{roomName}</RichText>
              </div>
              <Button
                onClick={toggleRoomPreferences(block.get('idx'))}
                innerStyle={[classes.roomToggle, showRoomPreference ? classes.up : classes.down]}
                rightIcon={{
                  unicodeContent: 'E052',
                  innerStyle: [classes.searchOptionsButtonIconOpen, showRoomPreference ? classes.up : classes.down ]
                }}
                ariaLabel={'_%personaliza tu habitación%_'}
                translate={true}
              />
            </div>
            <Form withoutForm={true} onChange={onChange} onBlur={onBlur} innerStyle={classes.roomPreferencesForm}>
              <div
                className={[showRoomPreference ? classes.show : classes.hide, classes.preferences].join(' ')}>
                {block.get('preferences').map(blockPreference => {
                  const preferenceId = blockPreference.get('preference_id');
                  const preference = hotelPreferences.find(preference => preference.get('id') === preferenceId);
                  return (
                    <div key={preferenceId} className={classes.preference}>
                      <RoomPreference
                        preference={preference}
                        optionId={blockPreference.get('option_id')}
                        blockIdx={block.get('idx')}
                      />
                    </div>
                  );
                })}
                <div className={classes.message}>
                  <RichText ucFirst={true} translate={true}>
                    _%selecciona tus preferencias. Las señaladas con asterisco no están garantizadas con la reserva
                    pero haremos lo posible por satisfacerlas%_
                  </RichText>
                </div>
              </div>
            </Form>
          </div>
        );
      })}
    </div>
  );
};

export default compose(
  withThemeJSS({ styleFile, link: true, displayName: 'CustomerForm' }),
  withContent('i18n')
)(RoomPreferences);
